<template>
  <div class="pa-6 bg-custom" id="role-content">
    <h2 class="mb-1">
      {{ $vuetify.lang.t('$vuetify.courseManagement.stepCourse.role') }}
    </h2>

    <v-row>
      <v-col cols="6">
        <v-card class="pa-4 mb-6" elevation="0">
          <p class="mb-2 body-1 font-weight-medium text-custom-title">
            {{ $vuetify.lang.t('$vuetify.showCreator') }}
          </p>
          <v-list subheader>
            <v-list-item
              v-for="chat in detail.owner_by_students.filter(
                (d) => d.initCreate
              )"
              :key="chat._id._id"
            >
              <v-list-item-avatar>
                <v-img
                  :alt="`${chat._id.image} avatar`"
                  :src="chat._id.image"
                ></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  v-text="`${chat._id.firstName} ${chat._id.lastName}`"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
        <v-card
          class="pa-4"
          elevation="0"
          v-if="$store.state.permission.adminCompany || isCreator()"
        >
          <p class="mb-2 body-1 font-weight-medium text-custom-title">
            {{ $vuetify.lang.t('$vuetify.setOwner') }}
          </p>
          <!-- <v-row v-if="$store.state.permission.adminCompany || isCreator()" justify="center"> -->
          <v-radio-group
            class="pl-3"
            v-model="setOwner"
            row
            @change="checkOwner"
          >
            <v-radio
              :label="$vuetify.lang.t('$vuetify.myself')"
              :value="false"
            ></v-radio>
            <v-radio
              :label="$vuetify.lang.t('$vuetify.otherInstructor')"
              :value="true"
            ></v-radio>
          </v-radio-group>
          <v-autocomplete
            v-model="selectInstructor"
            :items="teacherLists"
            item-text="fullName"
            :class="
              !setOwner ? 'pt-3 px-3 body-1 role-cursor' : 'pt-3 px-3 body-1'
            "
            item-value="id"
            outlined
            :placeholder="$vuetify.lang.t('$vuetify.chooseInstructor')"
            :background-color="!setOwner ? '#F5F5F5' : 'white'"
            :disabled="!setOwner"
            :search-input.sync="searchdata"
          >
            <!-- <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ $vuetify.lang.t('$vuetify.chooseInstructor') }}
                </v-list-item-title>
              </v-list-item>
            </template> -->
          </v-autocomplete>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card
          class="pa-4"
          height="352px"
          elevation="0"
          v-if="$store.state.permission.adminCompany || isCreator()"
        >
          <p class="mb-2 body-1 font-weight-medium text-custom-title">
            {{ $vuetify.lang.t('$vuetify.setAdmins') }}
          </p>
          <select-admin
            :updateAdmins="updateAdmins"
            :admins="admins"
          ></select-admin>
        </v-card>
      </v-col>
    </v-row>

    <div class="d-flex justify-end mt-3">
      <v-btn
        class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
        :disabled="!valid"
        @click="onUpload"
        elevation="0"
        style="float: right"
        v-if="$store.state.permission.adminCompany || isCreator()"
      >
        <v-icon v-if="this.$route.query.id" left>mdi-check</v-icon>
        {{
          this.$route.query.id
            ? $vuetify.lang.t('$vuetify.save')
            : $vuetify.lang.t('$vuetify.create')
        }}
      </v-btn>
    </div>

    <v-dialog v-model="dialogSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">บันทึกเรียบร้อย</v-card-title>

        <v-card-text>สามารถแก้ไขข้อมูลได้ภายหลัง</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialogSuccess = false"
            >เสร็จสิ้น</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import CounterMixin from './detail';
import selectAdmin from './small-item/select-admin';
import { getUserTeacherList } from '@/service/account/manageUser';

import {
  updateCourse,
} from '@/service/course/course';
import { cleaningData } from '@/helper/cleaningData';
export default {
  mixins: [CounterMixin],
  components: {
    'select-admin': selectAdmin,
  },
  data() {
    return {
      searchdata: '',
      teacherLists: [],
      isLoadInstructor: true,
      isSearchInstructor: false,
      paramsTeacher: {
        search: null,
        sort: 'created_at',
        sortby: -1,
        page: 1,
        limit: 10,
        active: 'null',
        isTeacher: 'y',
      },
    };
  },
  watch: {
    async searchdata(keyword) {
      this.paramsTeacher.search = keyword;
      this.paramsTeacher.limit =
        this.isLoadInstructor && this.selectInstructor != '' ? 1000 : 10;
      let teachers = await getUserTeacherList(this.paramsTeacher);
      if (teachers.data) {
        if (this.selectInstructor != '' && this.isLoadInstructor) {
          let arraySearch = teachers.data.filter(
            (item) => item._id == this.selectInstructor
          );
          if (arraySearch.length > 0) {
            this.teacherLists.push({
              fullName: `${arraySearch[0].firstName} ${arraySearch[0].lastName}`,
              id: arraySearch[0]._id,
            });
          }
          this.isLoadInstructor = false;
        } else {
          let lists = teachers.data.map((u) => {
            return {
              fullName: `${u.firstName} ${u.lastName}`,
              id: u._id,
            };
          });
          this.teacherLists = lists;
        }
      }
    },
  },
  methods: {
    updateAdmins(newAdmins) {
      this.admins = newAdmins;
    },
    isCreator() {
      const creator = this.detail.owner_by_students.filter(
        (d) => d.initCreate
      )[0];
      if (creator) {
        if (creator._id._id === this.$store.state._id) {
          return true;
        }
      }
      return false;
    },
    async updateCourse(courseID) {
      let status = null;
      let valueData = {
        ...this.detail,
        id: courseID,
        title: cleaningData(this.courseName),
        description: this.description,
        categories: [this.categoryId],
        skills: this.skillsId,
        grades: this.gradeId,
        tags: this.tagsId,
        image: this.imgPreview,
        haveDashboard: this.haveDashboard,
        useBoard: this.useBoard,
        haveInbox: this.haveInbox,
        learningOrder: this.learningOrder,
        localizations: [
          {
            title: cleaningData(this.courseName),
            lang: 'th',
          },
          {
            title: cleaningData(this.courseNameEng),
            lang: 'en',
          },
        ],
        certificate: this.certificate,
        percentCertificate:
          this.certificate == true ? this.percentCertificate : 0,
        urlCertificateTemplate:
          this.certificate == true ? this.imgPreview2 : '',
      };
      valueData.admins = this.admins;
      valueData.history = this.history;
      valueData.owner_by_students = [this.detail.owner_by_students[0]];
      if (this.setOwner) {
        valueData.owner_by_students[1] = {
          initCreate: false,
          _id: this.selectInstructor,
        };
      }
      status = await updateCourse(valueData);
      if (status.code == 403) {
        this.dialogAddFail = true; //กรณี error อื่น
        return false;
      } else {
        return status;
      }
    },
  },
};
</script>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
</style>
<style>
#role-content
  .role-cursor.v-input--is-disabled
  .v-input__control
  .v-select__slot
  input {
  pointer-events: auto;
  cursor: not-allowed;
}
</style>